import { SeminarType } from '@/api/graphql/codegen/graphql';
import { assertUnreachable } from '@/utils/assertUnreachable';

export const translateSeminarType = (type: SeminarType) => {
  switch (type) {
    case SeminarType.Default:
      return 'Klasický';
    case SeminarType.Idz:
      return 'Implementace dlouhodobého záměru Kraje Vysočina';
    case SeminarType.Digcompedu:
      return 'DigCompEdu';
    case SeminarType.Studium:
      return 'Kvalifikační studium';
    default:
      return assertUnreachable(type);
  }
};
